import React, { useEffect, useState, useCallback } from "react";
import ListDataKategoriDataCompOpenData from "../../../components/open_data/kategori/ListDataKategoriDataCompOpenData";
import SearchKategoriDataCompOpenData from "../../../components/open_data/kategori/SearchKategoriDataCompOpenData";
import { getGroups } from "../../../services/CkanApiService";

// ─── Helpers ──────────────────────────────────────────────────────────────────
const safeFormatDate = (dateString) => {
    if (!dateString) return "-";
    try {
        return dateString.split("T")[0];
    } catch {
        return "-";
    }
};

// ─── Component ────────────────────────────────────────────────────────────────
const ListDataKategoriDataOpenData = () => {
    const [data, setData]                 = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [totalItems, setTotalItems]     = useState(0);
    const [loading, setLoading]           = useState(false);
    const [searchQuery, setSearchQuery]   = useState("");

    // ── Fetch ────────────────────────────────────────────────────────────────
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // ✅ 1 request — all_fields=true sudah include package_count & image
                const groups = await getGroups();
                setData(groups);
                setFilteredData(groups);
                setTotalItems(groups.length);
            } catch (error) {
                console.error("fetchData kategori:", error.message);
                setData([]);
                setFilteredData([]);
                setTotalItems(0);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // ── Search / Filter ──────────────────────────────────────────────────────
    useEffect(() => {
        const query = searchQuery.toLowerCase();
        const filtered = query
            ? data.filter((item) => item.title?.toLowerCase().includes(query))
            : data;

        setFilteredData(filtered);
        setTotalItems(filtered.length);
    }, [searchQuery, data]);

    const handleSearch = useCallback((query) => {
        setSearchQuery(query);
    }, []);

    // ── Render ───────────────────────────────────────────────────────────────
    return (
        <div>
            <SearchKategoriDataCompOpenData onSearch={handleSearch} />
            <ListDataKategoriDataCompOpenData
                items={filteredData}
                totalItems={totalItems}
                formatDate={safeFormatDate}
                loading={loading}
            />
        </div>
    );
};

export default ListDataKategoriDataOpenData;
